exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1rfJsLqpvNxrg4RuxjAbjd{position:fixed;pointer-events:\"none\";z-index:1000;top:0;font-size:12px;font-weight:400}html[dir] ._1rfJsLqpvNxrg4RuxjAbjd{border-width:1px;border-style:solid;padding:0 4px;background:\"[theme:neutralTertiary, default:#a6a6a6]\"}html[dir=ltr] ._1rfJsLqpvNxrg4RuxjAbjd{left:0}html[dir=rtl] ._1rfJsLqpvNxrg4RuxjAbjd{right:0}", ""]);

// exports
exports.locals = {
	"dragHelperStyle": "_1rfJsLqpvNxrg4RuxjAbjd"
};